
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {deepCopy} from "@/auxillary";
import {ntdInstitutesModule} from "@/store";
import {rules} from "@/auxillary/rules";
import {flatObjectEqual} from "@/auxillary/flat-object-equal";
import NtdInstituteUpdateDto = MdbsCore.NtdInstituteUpdateDto;
import INtdInstituteDto = MdbsCore.INtdInstituteDto;
import NtdInstituteDto = MdbsCore.NtdInstituteDto;

@Component({})
export default class NtdInstituteEditDialog extends Vue {
  @Prop({required: true})
  ntdInstitute!: INtdInstituteDto;

  currentNtdInstitute: INtdInstituteDto = new NtdInstituteDto();
  saving = false;
  valid = false;
  hasChanges = false;

  rules: any = rules;

  @Watch('currentNtdInstitute', {deep: true})
  dataChanged() {
    console.log(("Entered dataChanged"))
    this.hasChanges = !flatObjectEqual(this.currentNtdInstitute, this.ntdInstitute, true);
  }

  @Watch('ntdInstitute', {immediate: true})
  async onInstituteChange(institute: INtdInstituteDto | null) {
    console.log(("Entered onInstituteChanged"))
    this.currentNtdInstitute = deepCopy(institute) ?? new NtdInstituteDto();
  }

  async save() {
    try {
      this.saving = true;

      await ntdInstitutesModule.updateNtdInstitute(new NtdInstituteUpdateDto(this.currentNtdInstitute));

      this.$emit('save');
    } finally {
      this.saving = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
